import { useEffect, useRef, useState } from 'react';

function useLoader() {
  const containerRef = useRef();
  const loaderRef = useRef();
  const [numLoader, setNumLoader] = useState(0);

  useEffect(() => {
    if (containerRef.current && loaderRef.current) {
      const containerHeight = containerRef.current.offsetHeight;
      const loaderHeight = loaderRef.current.offsetHeight;

      if (loaderHeight > 0) {
        const num = Math.floor(containerHeight / loaderHeight);
        setNumLoader(num);
      } else {
        setNumLoader(0); 
      }
    }
  }, [containerRef, loaderRef]); 

  return { containerRef, loaderRef, numLoader };
}

export default useLoader;
